const targets = new WeakMap<AudioParam, number>();
/** Replace automation at its current value; don't queue identical per-frame
 * targets forever (especially silence on every inactive ambience loop). */
export function audioTarget(param: AudioParam, value: number, now: number, seconds: number): void {
  if (targets.get(param) === value) return;
  targets.set(param, value);
  if (typeof param.cancelAndHoldAtTime === 'function') param.cancelAndHoldAtTime(now);
  else { const current = param.value; param.cancelScheduledValues(now); param.setValueAtTime(current, now); }
  param.setTargetAtTime(value, now, seconds);
}
